import api from "../../utilities/Interceptor";
import {decrypt} from "../../utilities/Encriptacion";
const url = process.env.REACT_APP_API_KEY

interface stroke {
    name: string;
    time1: string;
    time2: string;
    time3: string,
    comments: string
}
export interface IItinerary {
    name: string;
    stroke: stroke[]
}
export const getItinerary = (setItinerary: any, name: string, type: string) => {
    api.get<IItinerary>(`${url}/maps/newItinerary?name=${name}&type=${type}`).then((res) => {
        setItinerary(res.data);
    }).catch((error)=> {
        console.error(error);
    })
}

export const getOldItinerary = (setItinerary: any, id: number) => {
    api.get<IItinerary>(`${url}/maps/itinerary/${id}`).then((res) => {
        setItinerary(res.data);
    }).catch((error)=> {
        console.error(error);
    })
}

export const getRoutes = (setRoutes: any) => {
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION!;
    const encryptedData = sessionStorage.getItem('dataClient');
    const data = decrypt(encryptedData, CLAVE);
    const id = JSON.parse(data).id;

    api.get<IItinerary>(`${url}/maps/routesByClient/${id}`).then((res) => {
        setRoutes(res.data);
    }).catch((error)=> {
        console.error(error);
    })
}

export const getOldRoutes = (setRoutes: any) => {
    const CLAVE = process.env.REACT_APP_CLAVE_ENCRYPTION!;
    const encryptedData = sessionStorage.getItem('dataClient');
    const data = decrypt(encryptedData, CLAVE);
    const id = JSON.parse(data).id;

    api.get<IItinerary>(`${url}/maps/oldRoutesByClient/${id}`).then((res) => {
        setRoutes(res.data);
    }).catch((error)=> {
        console.error(error);
    })
}